export default __webpack_public_path__ + "static/media/adduser.5b5cfdb4.svg";